import {domLoader} from "@/loader.js";
import {debug} from "@/debug.js";

// اسپرایت آیکون‌ها (~۵۷KB) قبلا فقط بعد از آمادگی DOM درخواست می‌شد، یعنی
// تا آن لحظه همهٔ <use xlink:href="#..."> ها خالی بودند. درخواست را همین
// موقعِ ارزیابی ماژول شروع می‌کنیم تا با بقیهٔ منابع موازی شود؛ تزریق به
// DOM دقیقا در همان نقطهٔ قبلی و پشت همان گارد انجام می‌شود، پس زمان
// ظاهر شدن آیکون‌ها فقط زودتر می‌شود و هیچ‌وقت دیرتر نمی‌شود.
const iconSpritePromise = fetch('/assets/icons/icons.svg')
  .then(res => res.text())
  .catch(() => null);

window.iconsLoaded = false
domLoader(function () {
  if (window.iconsLoaded) return
  window.iconsLoaded = true
  debug.log("icon loader loaded")

  iconSpritePromise.then(svg => {
    if (!svg) return
    const div = document.createElement('div')
    div.style.display = 'none'
    div.innerHTML = svg
    document.body.insertBefore(div, document.body.firstChild)
  })
});
